import React, {Component} from 'react';
import '../../css/font-icon.css'
import './index.css'

export default class LoginAccountInput extends Component {
    constructor(props) {
        super(props);
        const lang = React.cookie.load("bby_lang") ? React.cookie.load("bby_lang") : window._bby_config.lang;
        const t = window._bby_config.country_code[lang];
        
        this.state={
            phoneType : t[0].type,
            phoneShow : false,
            error : props.error,
            accountType:props.mode || '',
            value:props.value,
            countryCode:props.mobileType || t[0].id,
            showClear:false,
            enable: props.enable || false,
            phoneTypeList:t
        }
    }

    phoneTypeSwitch = (event)=>{ 
        event.stopPropagation();
        const {phoneShow} = this.state;
        const {isreadonly} = this.props
        if(isreadonly){
            return
        }
        this.setState({phoneShow:!phoneShow})
    }

    phoneTypeChange = (event)=>{
        const s=event.target.parentNode.children;
        for(let i = 0; i <s.length; i++){
            s[i].classList.remove("select");
        }
        event.target.classList.add("select");
        const n = event.target.classList[0];
        this.setState({phoneType:n,countryCode:this.getCountryCode(n)})
    }

    getPhoneShowName = (n) =>{
        const {phoneTypeList} = this.state
        let lp=''
        phoneTypeList.map((objItem)=>{
            if(objItem.type===n) lp = objItem.showName
            return objItem.showName
        })
        return lp
    }

    getCountryCode = (n) =>{
        const {phoneTypeList} = this.state
        let lp=''
        phoneTypeList.map((objItem)=>{
            if(objItem.type===n) lp = objItem.id
            return objItem.id
        })
        return lp
    }

    componentDidMount() {
        this.props.getValue && this.props.getValue(this)
        document.addEventListener('click', this.hideAllMenu);
    }

    hideAllMenu = (event) =>{
        event.stopPropagation()
        const {phoneShow} = this.state
        if(phoneShow === true){
            this.setState({phoneShow:false})
        }
    }

    changeValue = (event) =>{
        const val = event.target.value
        const {mode} = this.props
        const regNum = /^[0-9]+$/g;
        var newRes= regNum.test(val);
        if(val!==''){
            this.setState({showClear:true})
        }else{
            this.setState({showClear:false})
        }

        if(mode==="mobile"){
            this.setState({value:val, accountType:'mobile'},()=>{
                if(this.props.onStopEdit) {
                    this.props.onStopEdit({value:val, accountType:'mobile'});
                }
            })
            return
        }

        if(mode==="email"){
            this.setState({value:val, accountType:'email'},()=>{
                if(this.props.onStopEdit) {
                    this.props.onStopEdit({value:val, accountType:'mobile'});
                }
            })
            return
        }

        if(newRes){
            event.target.parentNode.classList.add('phone')
            this.setState({accountType:'mobile'})
        }else{
            event.target.parentNode.classList.remove('phone')
            var re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
            if (re.test(val)) {
                this.setState({accountType:'email'})
            } else {
                this.setState({accountType:'account'})
            }
        }
        this.setState({value:val},()=>{
            if(this.props.onStopEdit) {
                this.props.onStopEdit({value:val, accountType:'mobile'});
            }
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({value:nextProps.value,error:nextProps.error})
    }

    getValue = () =>{
        const {value, accountType, phoneType, countryCode} = this.state;
        return {value, accountType, phoneType, countryCode}
    }

    clearInputValue = (event) =>{
        event.target.previousSibling.value="";
        const {mode} = this.props
        if(mode==="mobile"){
            return
        }
        event.target.parentNode.classList.remove('phone')
        this.setState({showClear:false,value:""})
    }

    blurValue = (event)=>{
        const val = event.target.value
        const {mode} = this.props
        const regNum = /^[0-9]+$/g;
        var newRes= regNum.test(val);
        if(val!==''){
            this.setState({showClear:true})
        }else{
            this.setState({showClear:false})
        }

        if(mode==="mobile"){
            this.setState({value:val, accountType:'mobile'},()=>{
                if(this.props.onStopEdit) {
                    this.props.onStopEdit({value:val, accountType:'mobile'});
                }
            })
            return
        }

        if(mode==="email"){
            this.setState({value:val, accountType:'email'},()=>{
                if(this.props.onStopEdit) {
                    this.props.onStopEdit({value:val, accountType:'mobile'});
                }
            })
            return
        }

        if(newRes){
            event.target.parentNode.classList.add('phone')
            this.setState({accountType:'mobile'})
        }else{
            event.target.parentNode.classList.remove('phone')
            var re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
            if (re.test(val)) {
                this.setState({accountType:'email'})
            } else {
                this.setState({accountType:'account'})
            }
        }
        this.setState({value:val},()=>{
            if(this.props.onStopEdit) {
                this.props.onStopEdit({value:val, accountType:'mobile'});
            }
        })
    }

    render() {
        const {phoneShow, phoneType,error, phoneTypeList, value, showClear, countryCode, enable} = this.state
        const {mode, isreadonly, placeholder, change, blur} = this.props
        return (
            <div className={`${mode === "mobile" ? "LoginAccountInput phone" : "LoginAccountInput"}${isreadonly ? " isreadonly": ""}`}>
                <div onClick={this.phoneTypeSwitch} className="mobileType">
                    <span>+{countryCode}</span>
                    <i className={`icon-bsy-xia ${phoneShow ? 'show' : ''}`}/>
                    {phoneShow && <ul style={{"display":phoneShow ? "block" : "none"}} onClick={this.phoneTypeChange} className="phoneTypeCon">
                        {
                            phoneTypeList.map((objItem)=>{
                                return <li key={objItem.id} className={phoneType === objItem.type ? `${objItem.type} select` : objItem.type}>{objItem.name}</li>
                            })
                        }
                    </ul>}
                </div>
                {isreadonly ?
                    <input className={`${error ? " error " : ""}${enable ? "enable " : ""}`} readOnly onBlur={blur ? blur : this.blurValue} onChange={change ? change : this.changeValue} value={value} onInput={(event)=>{
                        mode === "mobile" && (event.target.value=event.target.value.replace(/\D/g,''))
                    }} type="text" placeholder={placeholder ? placeholder : (mode === "mobile" ? React.language('msg.placeholder.phone') : mode === "email" ? React.language('msg.placeholder.mail') :  React.language('account.signin.phone.email'))}/>
                    : <input className={`${error ? "error " : ""}${enable ? "enable " : ""}`} type="text" onInput={(event)=>{
                        mode === "mobile" && (event.target.value=event.target.value.replace(/\D/g,''))
                    }} onBlur={blur ? blur : this.blurValue} onChange={change ? change : this.changeValue} value={value} placeholder={placeholder ? placeholder : (mode === "mobile" ? React.language('msg.placeholder.phone') : mode === "email" ? React.language('msg.placeholder.mail') :  React.language('account.signin.phone.email'))}/>}
                {!isreadonly && showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close"/>}
            </div>
        );
    }
}